import { render, staticRenderFns } from "./LlamarFichas.vue?vue&type=template&id=503c2a52&scoped=true"
import script from "./LlamarFichas.vue?vue&type=script&lang=ts"
export * from "./LlamarFichas.vue?vue&type=script&lang=ts"
import style0 from "./LlamarFichas.vue?vue&type=style&index=0&id=503c2a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c2a52",
  null
  
)

export default component.exports